<template>
  <v-dialog v-model="strandGoalkeeperDialog" persistent max-width="520" :retain-focus="false">
    <v-card tile flat v-if="gamedata && gamedata.rule === 'STRAND'">
      <v-card-title v-show="(!teamA.selectedGoalkeeper && !teamB.selectedGoalkeeper)" class="headline">Támadási irány</v-card-title>
      <v-card v-show="(!teamA.selectedGoalkeeper && !teamB.selectedGoalkeeper)" tile flat class="d-flex pa-4 align-center justify-center">
        <div>{{gamedata.team_a_name}}</div>
        <v-btn class="changeDirection" depressed tile @click="changeDirection(teamA.isActive ? 'right' : 'left')">
          <div v-if="teamA.isActive" class="direction-icon-holder">
            <svg class="arrow-icon" width="35" height="20" viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg"><path d="m20 0 8 8-8 8v-4.9798759h-8v-6.00031255h8zm-10 5v6h-2v-6zm-4 0v6h-2v-6zm-4 0v6h-2v-6z"/></svg>
          </div>
          <div v-if="teamB.isActive" class="direction-icon-holder">
            <svg class="arrow-icon" width="35" height="20" viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg"><path d="m8 0v5.01981155h8v6.00031255h-8v4.9798759l-8-8zm20 5v6h-2v-6zm-4 0v6h-2v-6zm-4 0v6h-2v-6z"/></svg>
          </div>
        </v-btn>
        <div>{{gamedata.team_b_name}}</div>
      </v-card>

      <v-card-title class="headline">Kapus kiválasztása</v-card-title>
      <v-card tile flat class="d-flex pa-4">
        <v-card tile flat class="width-100">
          <v-card tile flat class="text-center">{{teamA.isActive ? gamedata.team_b_shortname : gamedata.team_a_shortname}}</v-card>
          <v-select v-show="teamA.isActive" v-model="teamB.goalkeeper" class="width-100" return-object :items="getTeamGoalkeepers('B')"
                    item-text="name" label="Játékos" />
          <v-select v-show="teamB.isActive" v-model="teamA.goalkeeper" class="width-100" return-object :items="getTeamGoalkeepers('A')"
                    item-text="name" label="Játékos" />
        </v-card>
      </v-card>

      <v-card-actions>
        <v-spacer/>
        <v-btn depressed tile color="green" :disabled="!(teamA.isActive ? teamB.goalkeeper : teamA.goalkeeper)" @click="strandGoalkeeperDialogHandle">Mentés</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  props: {
    gamedata: Object,
    teamA: Object,
    teamB: Object,
    strandSelectedGoalkeeperA: String,
    strandSelectedGoalkeeperB: String,
  },
  methods: {
    ...mapActions('game', ['updateGoalkeeper', 'selectPlayer', 'saveStrandGoalkeepers']),
    ...mapMutations('game', ['SET_ATTACKING_DIRECTION']),
    ...mapMutations('ui', ['SET_STRAND_GOALKEEPER_DIALOG']),

    strandGoalkeeperDialogHandle() {
      // Segédfüggvény az ID kinyerésére (kezeli az .id és a .value esetet is)
      const getId = (obj) => {
        if (!obj) return null;
        return obj.id || obj.value || null;
      };

      const gkA = getId(this.teamA.goalkeeper);
      const gkB = getId(this.teamB.goalkeeper);

      this.saveStrandGoalkeepers({
        goalkeeperAId: gkA,
        goalkeeperBId: gkB
      });

      this.SET_STRAND_GOALKEEPER_DIALOG(false);
    },
    changeDirection(direction) {
      this.SET_ATTACKING_DIRECTION(direction);
    },
  },
  computed: {
    ...mapGetters('game', ['getTeamGoalkeepers']),
    ...mapState('ui', ['strandGoalkeeperDialog']),
  }
}
</script>

<style scoped>

</style>
